import { FormGroup, Validators } from '@angular/forms';
import { maxLenghtValidator } from '../../../validators/max-length.validator';
import { CommonService } from '../../../../core/providers/forms/common.service';
import { Numbers } from 'src/app/utils/constants';

export default class InsuredDataComponentUtils {


  //#region Constructor
  /**
   * @ignore
   */
  constructor(private commons: CommonService) {
    this.commons = commons;
  }
  patternEmail: RegExp = this.commons.patternsForm('email');
  patternMobile: RegExp = this.commons.patternsForm('mobile');
  patternCP: RegExp = this.commons.patternsForm('cp');
  prefixchanged: { name: string, value: any};
  disabledEmpApe1 = false;
  disabledEmpApe2 = false;
  public showModal2 = false;
  displayModal2: boolean;
  public showModal = false;
  displayModal: boolean;
  showNoRequiredSurname = 'legal.bussiness.first-surname.no-req';
  idMunicipioRecuperado = '';
  muniRecived: any;
  munichange: { name: string, value: any };
  provchange: { name: string, value: any };
  countrychange: { name: string, value: any };

  /**
   * getInsuredChoosed
   * @param formData formData
   * @param formConfig formConfig
   * @returns returns
   */
  public getInsuredChoosed(formData: any, formConfig: any): 'Particular' | 'Empresa' {
    let returnV: any;
    if (!formData) {
      returnV = '';
    } else {
      returnV = formData.get(formConfig.typeOwner.linkFormPath).value;
    }
    return returnV;
  }

  /**
   * removeValidator
   * @param formData formData
   * @param formConfig formConfig
   */
  public removeValidator(formData: any, formConfig: any): void {
    formData.get(formConfig.particular.name.linkFormPath).clearValidators();
    formData.get(formConfig.bussines.companySector.linkFormPath).clearValidators();
    formData.get(formConfig.bussines.direction.linkFormPath).clearValidators();
    formData.get(formConfig.typeOwner.linkFormPath).clearValidators();
    formData.get(formConfig.documentType.linkFormPath).clearValidators();
    formData.get(formConfig.documentNumber.linkFormPath).clearValidators();
    formData.get(formConfig.email.linkFormPath).clearValidators();
    formData.get(formConfig.prefix.linkFormPath).clearValidators();
    formData.get(formConfig.telephone.linkFormPath).clearValidators();
    formData.get(formConfig.direction.linkFormPath).clearValidators();
    formData.get(formConfig.postalCode.linkFormPath).clearValidators();
    formData.get(formConfig.municipality.linkFormPath).clearValidators();
    formData.get(formConfig.province.linkFormPath).clearValidators();
    formData.get(formConfig.country.linkFormPath).clearValidators();

    formData.get(formConfig.typeOwner.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.documentType.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.documentNumber.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.email.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.prefix.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.telephone.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.direction.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.postalCode.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.municipality.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.province.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.country.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.bussines.companySector.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.bussines.direction.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.particular.name.linkFormPath).updateValueAndValidity();
  }

  /**
   * @description asignar las validaciones del paso
   */
  public setValidator(formData: any, formConfig: any): void {
    const insuredChoosed: 'Particular' | 'Empresa' = this.getInsuredChoosed(formData, formConfig);
    if (insuredChoosed === 'Particular') {
      // Se limpia validación - empresa
      formData.get(formConfig.bussines.companySector.linkFormPath).clearValidators();
      formData.get(formConfig.bussines.direction.linkFormPath).clearValidators();
      formData.get(formConfig.bussines.companySector.linkFormPath).updateValueAndValidity();
      formData.get(formConfig.bussines.direction.linkFormPath).updateValueAndValidity();
      // Set validación particular
      formData.get(formConfig.particular.name.linkFormPath).setValidators([Validators.required]);
      formData.get(formConfig.particular.name.linkFormPath).updateValueAndValidity();
      const elemList: any = formConfig.documentType.options.list;
      elemList.map(
        (items: any, index: any) => {
          if (items.name === 'CIF') {
            formConfig.documentType.options.list.splice(index, 1);
          }
        }
      );
    }
    if (insuredChoosed === 'Empresa') {
      // Se limpia validación - particular
      formData.get(formConfig.particular.name.linkFormPath).clearValidators();
      formData.get(formConfig.particular.name.linkFormPath).updateValueAndValidity();
      // Set validación empresa
      formData.get(formConfig.bussines.companySector.linkFormPath).setValidators([Validators.required]);
      formData.get(formConfig.bussines.direction.linkFormPath).setValidators([Validators.required]);
      formData.get(formConfig.bussines.companySector.linkFormPath).updateValueAndValidity();
      formData.get(formConfig.bussines.direction.linkFormPath).updateValueAndValidity();
      formConfig.documentType.options.list.push({ name: 'CIF', id: Numbers.number2 });
    }
    formData.get(formConfig.typeOwner.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.documentType.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.documentNumber.linkFormPath).setValidators([maxLenghtValidator(
      Numbers.number15), Validators.required]);
    formData.get(formConfig.email.linkFormPath)
      .setValidators([Validators.pattern(this.patternEmail), Validators.required]);
    formData.get(formConfig.prefix.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.telephone.linkFormPath).setValidators(
      [Validators.pattern(this.patternMobile), Validators.required]);
    formData.get(formConfig.direction.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.postalCode.linkFormPath)
      .setValidators([Validators.pattern(this.patternCP), Validators.required]);
    formData.get(formConfig.municipality.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.province.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.country.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.firstSurname.linkFormPath).setValidators([Validators.required]);
    formData.get(formConfig.firstSurname.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.typeOwner.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.documentType.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.documentNumber.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.email.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.prefix.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.telephone.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.direction.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.postalCode.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.municipality.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.province.linkFormPath).updateValueAndValidity();
    formData.get(formConfig.country.linkFormPath).updateValueAndValidity();
  }

  /**
   * datalayer
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer(formData: any, gtmService: any): void {
    const formName: any = formData.get('insureSelected').value;
    const datalayerD: any = {
      event: 'ev_contratacion',
      event_category: 'contratacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 'c3'
    };

    gtmService.pushTag(datalayerD);
  }

  /**
   * datalayer2
   * @param formData formData
   * @param gtmService gtmService
   */
  datalayer2(formData: any, gtmService: any): void {
    const formName: any = formData.get('insureSelected').value;
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 't3'
    };
    gtmService.pushTag(datalayerD);
  }



  /**
   * @description blur en input número de documento, lanzando el evento comprobar cliente
   */
  checkDocumentBlur(keyValueName: any, formData: any, formConfig: any): boolean {
    const auxValueSurname: any = formData.get(formConfig.firstSurname.linkFormPath).value;
    const auxValueType: any = formData.get(formConfig.documentType.linkFormPath).value;
    const auxValueNum: any = formData.get(formConfig.documentNumber.linkFormPath).value;
    let result = false;
    let nameF = '';
    let auxValueName = '';
    if (this.getInsuredChoosed(formData, formConfig) === 'Particular') {
      auxValueName = formData.get(formConfig.particular.name.linkFormPath).value;
    }
    if (this.getInsuredChoosed(formData, formConfig) === 'Empresa') {
      auxValueName = formData.get(formConfig.bussines.direction.linkFormPath).value;
    }

    if (keyValueName.includes('documentNumber')) {
      nameF = 'documentNumber';
    }
    if (keyValueName.includes('name')) {
      nameF = 'name';
    }
    if (keyValueName.includes('firstSurname')) {
      nameF = 'firstSurname';
    }

    if (['documentNumber', 'name', 'firstSurname'].includes(nameF) &&
        (auxValueType.name === 'NIF' && auxValueNum !== '' && auxValueName !== '' && auxValueSurname !== '')) {
      result = true;
    }
    return result;
  }

  /**
   * checkDocumentNumber
   * @param val val
   * @param type type
   * @param patternPassport patternPassport
   * @returns returns
   */
  checkDocumentNumber(val: any, type: any, patternPassport: any): {name: string; value: string; type: string } {
    const auxValue: any = val;
    const auxValueLength: any = val.length;

    const docTypes: any = [
      { name: 'NIF', validation: this.commons.validateDNI },
      { name: 'DNI', validation: this.commons.validateDNI },
      { name: 'NIE', validation: this.commons.validateDNI },
      { name: 'Pasaporte', validation: patternPassport.test },
      { name: 'CIF', validation: this.commons.validateCif }
    ];

    let result: {name: string; value: string; type: string } = { name: '', value: '', type: '' };
    let validationResult = false;
    let selectedType: string;

    for (const element of docTypes) {
      if (element.name === type.name) {
        validationResult = !element.validation(auxValue);
        selectedType = element.name;
        break;
      }
    }

    if (auxValueLength < Numbers.number9) {
      result = { name: 'docNumber', value: 'error-min', type: selectedType };
    } else {
      if (validationResult) {
        result = { name: 'docNumber', value: 'valid', type: selectedType };
      } else {
        result = { name: 'docNumber', value: 'error', type: selectedType };
      }
    }
    return result;
  }

  /**
   * enableInputs
   * @param inputs inputs
   */
  enableInputs(inputs: any): void {
    inputs.forEach(disableInput => disableInput = false);
  }

  /**
   * disableInputs
   * @param inputs inputs
   */
  disableInputs(inputs: any): void {
    inputs.forEach(disableInput => disableInput = true);
  }

  /**
   * @description showModalDialog2
   */
  showModalDialog2(): void {
    this.displayModal2 = true;
    this.showModal2 = this.displayModal2;
  }

  /**
   * @description showModalDialog
   */
  showModalDialog(): void {
    this.displayModal = true;
    this.showModal = this.displayModal;
  }

  /**
   * @description getModalState2
   * @returns boolean
   */
  public getModalState2(): boolean {
    return this.showModal2;
  }

  /**
   * checkDay
   * @param dia dia
   * @returns returns
   */
  checkDay(dia: number): string {
    let day = '';
    if (dia < Numbers.number10) {
      day = '0';
    }
    return day;
  }

  /**
   * checkMonth
   * @param mes mes
   * @returns returns
   */
  checkMonth(mes: number): string {
    let month = '';
    if (mes < Numbers.number10) {
      month = '0';
    }
    return month;
  }

  /**
   * setDocumentoIdentidadCodigoPardot
   */
  setDocumentoIdentidadCodigoPardot(documentName: string): string {
    let documentoIdentidadCodigoValue = '';
    switch (documentName) {
      case 'NIF':
        documentoIdentidadCodigoValue = 'N';
        break;
      case 'NIE':
        documentoIdentidadCodigoValue = 'E';
        break;
      case 'Pasaporte':
        documentoIdentidadCodigoValue = 'P';
        break;
      case 'CIF':
        documentoIdentidadCodigoValue = 'C';
        break;
      default:
        documentoIdentidadCodigoValue = documentName;
        break;
    }
    return documentoIdentidadCodigoValue;
  }

  /**
   * aceptarConstentimiento
   * @param aceptCons aceptCons
   * @returns returns
   */
  aceptarConstentimiento(aceptCons: number): boolean {
    let consentimiento = true;
    if (aceptCons === 0) {
      consentimiento = false;
    }
    return consentimiento;
  }

  /**
   * setOrigenPardot
   * @param name string
   * @param countryOrigin string
   * @returns string
   */
  setOrigenPardot(name: string, countryOrigin: string): string {
    let origenValue = '';
    if (name) {
      origenValue = name;
    } else {
      origenValue = countryOrigin;
    }
    return origenValue;
  }

  /**
   * setPaisValuePardot
   * @param insuteSelectedChosed string
   * @param countryName string
   * @param country string
   * @returns string
   */
  setPaisValuePardot(insuteSelectedChosed: string, countryName: string, country: string): string {
    let paisValue = '';
    if (insuteSelectedChosed === 'incomingStudentsTravelAsistance') {
      paisValue = countryName;
    } else {
      paisValue = country;
    }
    return paisValue;
  }

  /**
   * getProductChoosedUtils
   * @param linkFormPath any
   * @param linkFormPathValue string
   */
  getProductChoosedUtils(linkFormPath: any, linkFormPathValue: string): void {
    if (linkFormPath !== '' && linkFormPathValue === 'CIF') {
      this.disabledEmpApe1 = true;
      this.disabledEmpApe2 = true;
    }
  }

  /**
   * @description validar si se habilita los campos de apellidos para CIF-Empresa
   * @param formData FormGroup
   * @param formConfig any
   */
  checkEnableCompany(formData: FormGroup, formConfig: any): void {
    if (formData.get(formConfig.documentType.linkFormPath).value.name === 'CIF' &&
        this.getInsuredChoosed(formData, formConfig) === 'Empresa') {
      this.disabledEmpApe1 = true;
      this.disabledEmpApe2 = true;
    }
  }

  /**
   * setFechaValuePardot
   * @param date any
   * @returns returns
   */
  setFechaValuePardot(date: any): string {
    let fechaValue = '';
    if (date && date.includes('/')) {
      // Obtener los valores de año, mes y día
      const [dia, mes, año]: [number, number, number] = date.split('/');
      fechaValue = año + '-' + mes + '-' + dia;
    }
    if (date && date.includes('-')) {
      const fechaToDate: Date = new Date(date.replace(/-/g, '/'));
      // Formatear la fecha como "yyyy-mm-dd"
      fechaValue = fechaToDate.getFullYear() + '-' + this.checkMonth(fechaToDate.getMonth() + 1) + fechaToDate.getMonth() + 1 + '-' +
        this.checkDay(fechaToDate.getDate()) + fechaToDate.getDate();
    }
    return fechaValue;
  }

  /**
   * setDestinoPardot
   * @returns returns
   */
  setDestinoPardot(countryDestiny: any, countryDestinyName: string, countryDestinyI: string): string {
    let destinoList = '';
    if (Array.isArray(countryDestiny) && countryDestiny.length >= 1) {
      countryDestiny.map((country, index) => {
        destinoList += country.name;
        if (index < countryDestiny.length - 1) {
          destinoList += ', ';
        }
      });
    } else if (countryDestinyName) {
      destinoList = countryDestinyName;
    } else if (countryDestinyI) {
      destinoList = countryDestinyI;
    } else {
      destinoList = countryDestiny;
    }
    return destinoList;
  }
/**
 * changePrefixUtils
 * @param individualTravelAsistance any
 * @param sportTravelAsistance any
 * @param particularTravelAsistance any
 * @param incomingStudentsTravelAsistance any
 */
  changePrefixUtils(individualTravelAsistance: any, sportTravelAsistance: any, particularTravelAsistance: any,
                    incomingStudentsTravelAsistance: any): void {
    let formData: any;
    if (individualTravelAsistance) {
      formData = individualTravelAsistance;
    }
    if (!individualTravelAsistance && sportTravelAsistance) {
      formData = sportTravelAsistance;
    }
    if (!individualTravelAsistance && !sportTravelAsistance && particularTravelAsistance) {
      formData = particularTravelAsistance;
    } else {
      if (incomingStudentsTravelAsistance) {
        formData = incomingStudentsTravelAsistance;
      }
    }
    if (formData.insuredData.prefix.id === '+34' || formData.insuredData.prefix === 'España (+34)') {
      this.prefixchanged = { name: 'prefix', value: '9' };
    } else {
      this.prefixchanged = { name: 'prefix', value: '13' };
    }
  }

  /**
   * changeMunicipality
   * @param municipality any
   * @param dataSpain any
   */
  changeMunicipality(municipality: any, dataSpain: any): void {
    if (this.idMunicipioRecuperado !== '') {
      municipality.forEach(item => {
        if (item.Id_Municipio === this.idMunicipioRecuperado) {
          this.muniRecived = item;
        }
      });
      this.munichange = { name: 'municipio', value: this.muniRecived };
      this.provchange = { name: 'provincia', value: this.muniRecived.Des_Provincia };
      this.countrychange = { name: 'country', value: dataSpain[0] };
    } else {
      this.munichange = { name: 'municipio-list', value: municipality };
      this.countrychange = { name: 'country', value: dataSpain[0] };
    }
  }

  /**
   * changeMuniUtils
   * @param event any
   */
  changeMuniUtils(event: any): void {
    const dataSpain: any = [];
    dataSpain.push({ id: Numbers.number67, name: 'España', code: 'España' });
    this.provchange = { name: 'provincia', value: event.Des_Provincia };
    this.countrychange = { name: 'country', value: dataSpain[0] };
  }

  /**
   * Transform the email to lowerCase
   * @param formData formData
   * @param formConfig formCongig
   */
  transformLower(formData: any, formConfig: any): void {
    const LOWER: string = formData.get(formConfig.email.linkFormPath).value.toString().toLowerCase();
    formData.get(formConfig.email.linkFormPath).setValue(LOWER);
  }
}

